import "./footer.scss";

import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Grid } from "@mui/material";

import {
    AccountBalanceOutlined,
    MenuBookOutlined,
    LocationOnOutlined,
    VideoLibraryOutlined,
    PhoneOutlined,
    EmailOutlined,
    PlaceOutlined,
    ChevronRight,
    VerifiedUserOutlined,
    Facebook,
    LinkedIn,
    Instagram,
    YouTube,
} from "@mui/icons-material";

import "./footer.scss";

function FooterNew() {
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const isVrDarshan = location.pathname.startsWith("/vr-darshan");
    const isIndiaMap = location.pathname.startsWith("/india-map") || location.pathname.startsWith("/india-temples");
    const isSarthiPage = location.pathname.includes("sarthi");
    const isNaviStick = location.pathname.includes("navi-stick");
    const isReunite = location.pathname.includes("reunite");
    const isVaishnoDevi = location.pathname.includes("vaishno");
    const noTopMargin = isHomePage || isVrDarshan || isIndiaMap || isSarthiPage || isNaviStick || isReunite || isVaishnoDevi;

    const quickLinks = [
        {
            title: "Temples",
            icon: <AccountBalanceOutlined />,
            link: "/listing",
        },
        {
            title: "Spiritual Stories",
            icon: <MenuBookOutlined />,
            link: "/coming-soon",
        },
        {
            title: "Yatras & Pilgrimage",
            icon: <LocationOnOutlined />,
            link: "/coming-soon",
        },
        {
            title: "Videos",
            icon: <VideoLibraryOutlined />,
            link: "/vr-darshan",
        },
    ];

    const companyLinks = [
        {
            title: "About Us",
            link: "/about-us",
        },
        {
            title: "Careers",
            link: "/career",
        },
        {
            title: "Terms & Conditions",
            link: "/terms-condition",
        },
        {
            title: "Privacy Policy",
            link: "/privacy-policy",
        },
        {
            title: "Refund Policy",
            link: "/refund-policy",
        },
    ];

    const socialLinks = [
        {
            icon: <Facebook />,
            link: "https://www.facebook.com/",
            label: "Facebook",
        },
        {
            icon: <LinkedIn />,
            link: "https://www.linkedin.com/company/arixpower/",
            label: "LinkedIn",
        },
        {
            icon: "X",
            link: "https://x.com/",
            label: "X",
        },
        {
            icon: <Instagram />,
            link: "https://www.instagram.com/mandirwikiofficial",
            label: "Instagram",
        },
        {
            icon: <YouTube />,
            link: "https://www.youtube.com/",
            label: "YouTube",
        },
    ];

    return (
        <footer
            className={`siteFooter ${noTopMargin ? "noMarginTop" : "innerPageFooter"}${isHomePage ? " isHomePage" : ""}${isVrDarshan ? " vrDarshanPage" : ""}${isIndiaMap ? " indiaMapPage" : ""}${isSarthiPage ? " sarthiPage" : ""}${isVaishnoDevi ? " vaishnoDeviPage" : ""}`}
        >
            {/* =========================================
          NEWSLETTER
      ========================================= */}
            <div className="newsletterWrapper">
                <Container maxWidth="lg">
                    <div className="newsletterBox">
                        {/* NEWSLETTER CONTENT */}
                        <div className="newsletterInfo">
                            <h3>Sign up for our newsletter</h3>

                            <p>Get the latest updates on temples, stories and spiritual journeys.</p>
                        </div>

                        {/* EMAIL */}
                        <div className="newsletterForm">
                            <div className="newsletterInput">
                                <EmailOutlined />

                                <input type="email" placeholder="Enter your mail" />
                            </div>
                        </div>

                        {/* APP DOWNLOAD */}
                        <div className="newsletterDownload">
                            <h3>
                                Download
                                <br />
                                MandirWiki App
                            </h3>

                            <div className="newsletterStores">
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.mandir.wiki&pcampaignid=web_share"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="storeLink"
                                >
                                    <img src="/assets/home/icons/google-play.png" alt="Get it on Google Play" />
                                </a>

                                <a href="/coming-soon" className="storeLink">
                                    <img src="/assets/home/icons/app-store.png" alt="Download on the App Store" />
                                </a>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

            {/* =========================================
          MAIN FOOTER
      ========================================= */}
            <div className="footerMain">
                <Container maxWidth="lg">
                    <Grid
                        container
                        spacing={{
                            xl: 5,
                            lg: 4,
                            md: 4,
                            sm: 4,
                            xs: 3,
                        }}
                    >
                        {/* BRAND */}
                        <Grid
                            size={{
                                xl: 5,
                                lg: 5,
                                md: 12,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <div className="footerBrand">
                                <a href="/" className="footerLogo">
                                   <img src="/assets/home/logo.png" className="img-fluid" alt="Mandir Wiki" />
                                </a>

                                <p className="footerDescription">
                                    Mandirwiki is an aggregator platform that consolidates reliable temple details, trip
                                    planning tools, flight booking, hotels, temple services, and more to provide an
                                    end-to-end pilgrimage solution. We have achieved a significant milestone by
                                    inaugurating the locker booking service at Shri Mata Vaishno Devi Shrine Board
                                    (SMVDSB). Owned by Arixpower India Pvt. Ltd.
                                </p>

                                <div className="certificate">
                                    <div className="certificateIcon">
                                        <a href="/assets/startup-india-certificate.pdf" target="_blank" rel="noopener noreferrer">
                                            <img src="/assets/ashok-stambh.png" className="img-fluid" alt="Certificate" />
                                        </a>
                                    </div>

                                    <strong>
                                        <a href="/assets/startup-india-certificate.pdf" className="text-white text-decoration-none" target="_blank" rel="noopener noreferrer">
                                            Certificate Number: DIPP174000
                                        </a>
                                    </strong>
                                </div>
                            </div>
                        </Grid>

                        {/* QUICK LINKS */}
                        <Grid
                            size={{
                                xl: 2,
                                lg: 2,
                                md: 4,
                                sm: 6,
                                xs: 12,
                            }}
                        >
                            <div className="footerColumn">
                                <h3>Quick Links</h3>

                                <div className="headingLine" />

                                <div className="footerLinks">
                                    {quickLinks.map((item, index) => (
                                        <a href={item.link} className="footerLink" key={index}>
                                            <span className="linkIcon">{item.icon}</span>

                                            <span className="linkTitle">{item.title}</span>

                                            <ChevronRight className="linkArrow" />
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </Grid>

                        {/* CONTACT */}
                        <Grid
                            size={{
                                xl: 3,
                                lg: 3,
                                md: 4,
                                sm: 6,
                                xs: 12,
                            }}
                        >
                            <div className="footerColumn">
                                <h3>Contact Us</h3>

                                <div className="headingLine" />

                                <div className="contactList">
                                    <div className="contactItem">
                                        <PhoneOutlined />

                                        <a href="tel:+919625974411">+91 9625974411</a>
                                    </div>

                                    <div className="contactItem">
                                        <EmailOutlined />

                                        <a href="mailto:info@mandir.wiki">info@mandir.wiki | info@arixpower.com</a>
                                    </div>

                                    <div className="contactItem">
                                        <PlaceOutlined />

                                        <p>203, 2-A/3, S/F Front Side, Asaf Ali Road, Turkman Gate, New Delhi-110002</p>
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        {/* COMPANY */}
                        <Grid
                            size={{
                                xl: 2,
                                lg: 2,
                                md: 4,
                                sm: 6,
                                xs: 12,
                            }}
                        >
                            <div className="footerColumn">
                                <h3>Company</h3>

                                <div className="headingLine" />

                                <div className="footerLinks">
                                    {companyLinks.map((item, index) => (
                                        <a href={item.link} className="footerLink companyLink" key={index}>
                                            <span className="linkTitle">{item.title}</span>

                                            <ChevronRight className="linkArrow" />
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>

            {/* =========================================
          FOOTER BOTTOM
      ========================================= */}
            <div className="footerBottom">
                <Container maxWidth="lg">
                    <div className="footerBottomInner">
                        {/* COPYRIGHT */}
                        <div className="copyright">
                            <VerifiedUserOutlined />

                            <span>© 2025 MandirWiki. All rights reserved.</span>
                        </div>

                        {/* SOCIAL */}
                        <div className="socialSection">
                            <span className="followText">Follow us on</span>

                            <div className="socialLinks">
                                {socialLinks.map((item, index) => (
                                    <a
                                        href={item.link}
                                        aria-label={item.label}
                                        className="socialLink"
                                        key={index}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {item.icon}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </footer>
    );
}

export default FooterNew;
